import { OkdocTrackingPageContent } from '@/features/okdoc/admin/OkdocTrackingPageContent';

export function OkdocTrackingPage() {
  return <OkdocTrackingPageContent />;
}
